import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../../lib/api-client';

export interface AppNotification {
  id: string;
  type: string;
  title: string;
  body: string | null;
  metadata: { ticketId?: string; messageId?: string; reason?: string } | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  data: AppNotification[];
  unread: number;
}

export const notificationsApi = {
  async list(): Promise<NotificationsResponse> {
    const { data } = await apiClient.get<NotificationsResponse>('/v1/notifications');
    return data;
  },
  async markRead(id: string): Promise<void> {
    await apiClient.patch(`/v1/notifications/${id}/read`);
  },
  async markAllRead(): Promise<void> {
    await apiClient.post('/v1/notifications/read-all');
  },
};

export function useNotifications() {
  return useQuery({
    queryKey: ['notifications', 'list'],
    queryFn: () => notificationsApi.list(),
    staleTime: 30_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationsApi.markRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications', 'list'] }),
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications', 'list'] }),
  });
}
